module.exports = __webpack_public_path__ + "fonts/exo-bold-webfont.40fd6ec1.ttf";